module.exports = __webpack_public_path__ + "static/media/file4.9ab073fd.png";